if (!customElements.get('product-jump-nav')) {
  customElements.define(
    'product-jump-nav',
    class ProductJumpNav extends HTMLElement {
      constructor() {
        super();
        this.tabsList = this.querySelector('.product-jump-nav__tabs');
        this.indicator = this.querySelector('.product-jump-nav__indicator');
        this.nextButton = this.querySelector('.product-jump-nav__next');
        this.tabs = Array.from(this.querySelectorAll('.product-jump-nav__tab-link'));

        this.targets = this.tabs
          .map((tab) => {
            const selector = tab.dataset.jumpTarget;
            if (!selector) return null;
            const target = document.querySelector(selector);
            if (!target) {
              console.warn(`product-jump-nav: no element matches "${selector}"`);
              return null;
            }
            return { tab, target };
          })
          .filter(Boolean);

        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));

        this.buyWrapper = this.querySelector('.product-jump-nav__buy');
        if (this.buyWrapper) this.buyWrapper.addEventListener('click', this.onBuyWrapperClick.bind(this));

        if (this.nextButton && this.tabsList) {
          this.nextButton.addEventListener('click', this.onNextClick.bind(this));
          this.tabsList.addEventListener('scroll', this.updateNextButton.bind(this));
          window.addEventListener('resize', this.updateNextButton.bind(this));
          this.updateNextButton();
        }

        if (this.tabsList) {
          this.tabsList.addEventListener('scroll', () => {
            if (this.activeTab) this.positionIndicator(this.activeTab);
          });
        }

        this.setupDragToScroll();

        if (this.tabs.length) this.setActiveTab(this.tabs[0]);
        if (this.targets.length) this.observeTargets();

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            const current = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
            if (current) this.positionIndicator(current);
            this.updateNextButton();
          });
        }
      }

      setupDragToScroll() {
        if (!this.tabsList) return;
        let isDown = false;
        let dragged = false;
        let startX = 0;
        let startScroll = 0;

        this.tabsList.addEventListener('mousedown', (event) => {
          isDown = true;
          dragged = false;
          startX = event.pageX;
          startScroll = this.tabsList.scrollLeft;
          this.tabsList.classList.add('is-dragging');
        });

        window.addEventListener('mouseup', () => {
          if (!isDown) return;
          isDown = false;
          this.tabsList.classList.remove('is-dragging');
        });

        window.addEventListener('mousemove', (event) => {
          if (!isDown) return;
          const delta = event.pageX - startX;
          if (Math.abs(delta) > 4) dragged = true;
          this.tabsList.scrollLeft = startScroll - delta;
        });

        this.tabsList.addEventListener(
          'click',
          (event) => {
            if (!dragged) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
      }

      onNextClick() {
        if (!this.tabsList) return;
        this.tabsList.scrollBy({ left: this.tabsList.clientWidth * 0.8, behavior: 'smooth' });
      }

      updateNextButton() {
        if (!this.nextButton || !this.tabsList) return;
        const atEnd = this.tabsList.scrollLeft + this.tabsList.clientWidth >= this.tabsList.scrollWidth - 1;
        this.nextButton.toggleAttribute('disabled', atEnd);
      }

      onBuyWrapperClick(event) {
        if (event.target.closest('.product-form__submit')) return;
        const submitButton = this.buyWrapper.querySelector('.product-form__submit');
        if (submitButton) submitButton.click();
      }

      getHeaderOffset() {
        const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const height = parseInt(value, 10);
        return Number.isNaN(height) ? 0 : height;
      }

      onTabClick(event) {
        event.preventDefault();
        this.setActiveTab(event.currentTarget);

        const selector = event.currentTarget.dataset.jumpTarget;
        if (!selector) return;
        const target = document.querySelector(selector);
        if (!target) {
          console.warn(`product-jump-nav: no element matches "${selector}"`);
          return;
        }

        const top = target.getBoundingClientRect().top + window.scrollY - this.getHeaderOffset() - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }

      observeTargets() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const match = this.targets.find((item) => item.target === entry.target);
              if (match) this.setActiveTab(match.tab);
            });
          },
          { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
        );

        this.targets.forEach((item) => observer.observe(item.target));
      }

      positionIndicator(activeTab) {
        if (!this.indicator || !this.tabsList) return;
        const indicatorWidth = this.indicator.offsetWidth;
        const tabCenter = activeTab.offsetLeft + activeTab.offsetWidth / 2;
        this.indicator.style.left = `${tabCenter - indicatorWidth / 2 - this.tabsList.scrollLeft}px`;
      }

      setActiveTab(activeTab) {
        this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab === activeTab));
        this.activeTab = activeTab;
        this.positionIndicator(activeTab);

        if (!this.tabsList) return;
        const outOfViewLeft = activeTab.offsetLeft < this.tabsList.scrollLeft;
        const outOfViewRight =
          activeTab.offsetLeft + activeTab.offsetWidth > this.tabsList.scrollLeft + this.tabsList.clientWidth;
        if (outOfViewLeft || outOfViewRight) {
          this.tabsList.scrollTo({ left: activeTab.offsetLeft - 16, behavior: 'smooth' });
        }
      }
    }
  );
}
